const SAO_PAULO = 'America/Sao_Paulo';

export function formatStatementDay(day: string, locale: string): string {
  const [y, m, d] = day.split('-').map(Number);
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(Date.UTC(y, m - 1, d, 12)));
}

export function formatStatementTime(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit', minute: '2-digit', timeZone: SAO_PAULO,
  }).format(new Date(iso));
}

export function formatStatementDateTime(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: SAO_PAULO,
  }).format(new Date(iso));
}
